function getForwardWordBreakIndex(str, index, wordRegex) {
    let result = 0;
    while (wordRegex.exec(str) != null) {
        result = wordRegex.lastIndex;
        if (wordRegex.lastIndex > index)
            break;
    }
    wordRegex.lastIndex <= index && (result = str.length);
    return result;
}
function getBackwardWordBreakIndex(str, index, wordRegex) {
    let result = 0;
    let execArray;
    while ((execArray = wordRegex.exec(str)) != null) {
        if (wordRegex.lastIndex - execArray[0].length < index)
            result = wordRegex.lastIndex - execArray[0].length;
        else
            break;
    }
    return result;
}
export function getAdjecentWordBreakIndex(str, index, direction) {
    const wordRegex = /([\wåäöüéáúíóßðœøæñµçþ_]+|[@-]+)/gi;
    return direction == "backward"
        ? getBackwardWordBreakIndex(str, index, wordRegex)
        : getForwardWordBreakIndex(str, index, wordRegex);
}
//# sourceMappingURL=getAdjecentWordBreakIndex.js.map